import type { FaireProductEntity } from "../../entity_types/product";

export const p_ft77ghjjhv: FaireProductEntity = {
  token: "p_ft77ghjjhv",
  type: "product",
  name: "Minnesota State Shape Loons 4 Layer Wood Ornament",
  brandName: "Token Atelier",
  imageUrl:
    "https://cdn.faire.com/fastly/69303b50f93bff5a8ec4eea0f14d02dec64f5468398232838aef9e618aed9fa4.png",
  priceDollars: 4.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/03d3ee1fb5f434e6df17e7dc1c736a1495b095d51c2a1be7cbc7853a2ab739fc.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
